import { useState } from "react";
import { Link } from "react-router-dom";
import { QrCode, Menu, X } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

const LINKS = [
  { href: "/#producto", label: "Producto", testid: "nav-link-producto" },
  { href: "/#como-funciona", label: "Cómo funciona", testid: "nav-link-como-funciona" },
  { href: "/#porque-nosotros", label: "Por qué nosotros", testid: "nav-link-porque-nosotros" },
  { href: "/demo", label: "Demo", testid: "nav-link-demo" },
];

export default function LandingNav() {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 backdrop-blur-md bg-white/80 border-b border-zinc-200/80" data-testid="header-navigation">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-20 h-16 flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-2.5 shrink-0" data-testid="header-logo">
          <span className="h-9 w-9 rounded-xl bg-zinc-900 text-white flex items-center justify-center">
            <QrCode size={17} />
          </span>
          <span className="font-heading font-bold text-lg tracking-tight">Asset Passport</span>
        </Link>

        <nav className="hidden lg:flex items-center gap-1">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.testid}
              className="px-4 py-2 rounded-full text-sm font-medium text-zinc-500 hover:text-zinc-950 hover:bg-zinc-100 transition-colors duration-200"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          {user ? (
            <Link
              to="/app"
              data-testid="nav-login-button"
              className="px-4 py-2 rounded-full text-sm font-medium text-zinc-600 hover:text-zinc-950 transition-colors"
            >
              Ir a la aplicación
            </Link>
          ) : (
            <Link
              to="/login"
              data-testid="nav-login-button"
              className="px-4 py-2 rounded-full text-sm font-medium text-zinc-600 hover:text-zinc-950 transition-colors"
            >
              Iniciar sesión
            </Link>
          )}
          <Link
            to={user ? "/app/machines/new" : "/solicitar-acceso"}
            data-testid="nav-create-machine-cta"
            className="inline-flex items-center px-5 py-2.5 rounded-full bg-zinc-900 text-white text-sm font-medium hover:bg-zinc-800 active:scale-95 transition-[background-color,transform] duration-200"
          >
            {user ? "Crear mi primera máquina" : "Probar Asset Passport"}
          </Link>
        </div>

        <button
          className="lg:hidden h-10 w-10 rounded-full border border-zinc-200 bg-white flex items-center justify-center text-zinc-700"
          onClick={() => setOpen(!open)}
          data-testid="mobile-menu-toggle"
          aria-label="Abrir menú"
        >
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-zinc-200/80 bg-white/95 backdrop-blur-md px-6 py-4 space-y-1" data-testid="mobile-menu">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="block px-3 py-3 rounded-xl text-base font-medium text-zinc-700 hover:bg-zinc-100"
            >
              {l.label}
            </a>
          ))}
          <div className="pt-3 flex flex-col gap-2">
            <Link
              to={user ? "/app" : "/login"}
              onClick={() => setOpen(false)}
              className="text-center px-4 py-3 rounded-full border border-zinc-200 text-sm font-medium"
            >
              {user ? "Ir a la aplicación" : "Iniciar sesión"}
            </Link>
            <Link
              to={user ? "/app/machines/new" : "/solicitar-acceso"}
              onClick={() => setOpen(false)}
              className="text-center px-4 py-3 rounded-full bg-zinc-900 text-white text-sm font-medium"
            >
              {user ? "Crear mi primera máquina" : "Probar Asset Passport"}
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
